import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

const Contact = () => {
  const Links = [
    {
      id: 1,
      child: (
        <>
          <FaLinkedin size={40} />
        </>
      ),
      href: "https://www.linkedin.com/in/0xsahil/",
    },
    {
      id: 2,
      child: (
        <>
          <FaGithub size={40} />
        </>
      ),
      href: "https://github.com/0xsahil",
    },
    {
      id: 3,
      child: (
        <>
          <HiOutlineMail size={40} />
        </>
      ),
      href: "mailto:0xsahilv@gmail.com",
    },
    {
      id: 4,
      child: (
        <>
          <BsFillPersonLinesFill size={40} />
        </>
      ),
      href: "./SB_Resume.pdf",
      download: true,
    },
  ];
  return (
    <div name="contact" className="p-4 text-white">
      <div className="flex flex-col p-4 justify-center mx-auto ">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Contact Me
          </p>
          <p className=" py-6">Fill out details to get in touch with me </p>
        </div>

        <div className=" flex justify-center items-center">
          <form
            action="https://getform.io/f/83bbbbea-3abe-4b2a-a399-ef9eb1f2f172"
            method="POST"
            className="flex flex-col w-full md:w-1/2"
          >
            <input
              required
              type="text"
              name="name"
              placeholder="Full name...."
              className=" p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <input
              required
              type="email"
              name="email"
              placeholder="e-mail...."
              className="my-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <textarea
              name="message"
              rows="10"
              placeholder="Message...."
              className=" p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            ></textarea>
            <button className="magnetButton text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300 cursor-none">
              Let's Talk
            </button>
          </form>
        </div>

        <div className="lg:hidden flex flex-row justify-center items-center">
          <ul className="flex flex-row items-center justify-center">
            {Links.map(({ id, child, href, download }) => {
              return (
                <li key={id} className="magnetButton hover:scale-110 mx-2 p-2">
                  <a
                    href={href}
                    target={"_blank"}
                    rel="noreferrer"
                    download={download}
                  >
                    {child}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Contact;
